import { Activity as ActivityIcon } from "lucide-react";
import { EmptyState } from "@/components/ui";
import { TraceEventItem } from "./TraceEventItem";
import type { Activity } from "./types";

export function TraceTimeline({ activities }: { activities: Activity[] }) {
  if (activities.length === 0) {
    return (
      <EmptyState
        icon={<ActivityIcon className="h-5 w-5 animate-pulse" />}
        title="Wachten op trace-events…"
        description="Stappen verschijnen hier zodra de agent aan de vraag werkt."
      />
    );
  }
  return (
    <ol className="pt-1">
      {activities.map((activity, index) => (
        <TraceEventItem key={index} activity={activity} isLast={index === activities.length - 1} />
      ))}
    </ol>
  );
}
